import CATEGORIA from './GET_CATEGORIA.gql';
import POST from './GET_POST.gql';
import SAVELOG from './REGISTER_LOG.gql';

export function query(graphql, name, value = {}) {
  const queryName = name === 'categoria' ? CATEGORIA : name === 'post' ? POST : null;
  return graphql.query({
    query: queryName,
    variables: value,
    fetchPolicy: 'no-cache',
  });
}

export function mutation(graphql, value = {}) {
  console.log(value);
  return graphql.mutate({
    mutation: SAVELOG,
    variables: value,
  });
}
